/* eslint-disable react/jsx-pascal-case */
import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import NavBar from "../../../components/navbar/navbar";
import {
  MaterialReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFullScreenButton,
  useMaterialReactTable,
} from "material-react-table";
import {
  ActionTypes,
  ArgumentActionTypes,
  Error,
  OfferResponse,
  OfferRow,
  OfferState,
} from "./types";
import { API_URL, sentActionLog, verify } from "../../../utils/common";
import swal from "sweetalert";
import { ModalContainer } from "../styles";
import OfferReducer, { ArgumentReducer } from "./reducer";
import { catalog } from "../../../models";
import { Edit, Delete } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";

const initialState = {
  classificationId: 0,
  acId: undefined,
  playId: 0,
  typeId: 0,
  internetPlanId: undefined,
  mobilePlanId: undefined,
  videoPlanId: undefined,
  internetPlanPromoId: undefined,
  internetPlanPromoDuration: "",
  advancePaymentPromo: "",
  channelsApps: "",
  permanentPromo: undefined,
  promoPrice: "",
  price: "",
  promoPriceDuration: "",
  expirationDate: "",
  addMobilePromo: undefined,
  addMobilePromoDuration: undefined,
  arguments: [],
};

const argumentInitialState = {
  competitorId: 0,
  plan: "",
  competitorPrice: "",
  competitorPromoPrice: "",
  promos: "",
  description: "",
};

const Offers: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = React.useState<OfferRow[]>([]);
  const [rowCount, setRowCount] = React.useState<number>(0);
  const [columnFilters, setColumnFilters] = React.useState<MRT_ColumnFiltersState >([]);
  const [open, setOpen] = React.useState<boolean>(false);
  const [openAddArgument, setOpenAddArgument] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [state, dispatch] = React.useReducer(OfferReducer, initialState);
  const [argumentState, argumentDispatch] = React.useReducer(
    ArgumentReducer,
    argumentInitialState
  );
  const [classifications, setClassifications] = React.useState<catalog[]>([]);
  const [acs, setAcs] = React.useState<catalog[]>([]);
  const [plays, setPlays] = React.useState<catalog[]>([]);
  const [types, setTypes] = React.useState<catalog[]>([]);
  const [error, setError] = React.useState<Error | undefined>(undefined);
  const [internetPlans, setInternetPlans] = React.useState<catalog[]>([]);
  const [mobilePlans, setMobilePlans] = React.useState<catalog[]>([]);
  const [videoPlans, setVideoPlans] = React.useState<catalog[]>([]);
  const [competitors, setCompetitors] = React.useState<catalog[]>([]);
  const [modalTitle, setModalTitle] = React.useState<string>("");
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const columns = React.useMemo<MRT_ColumnDef<OfferRow>[]>(
    () => [
      {
        accessorKey: "classification.name",
        header: "Clasificación",
        filterVariant: 'select',
        filterSelectOptions: classifications.map(item => ({...item, value: item.value.toString()}))
      },
      {
        accessorKey: "ac.name",
        header: "AC",
        enableColumnFilter: false
      },
      {
        accessorKey: "play.name",
        header: "Play",
        filterVariant: 'select',
        filterSelectOptions: plays.map(item => ({...item, value: item.value.toString()}))
      },
      {
        accessorKey: "type.name",
        header: "Tipo",
        filterVariant: 'select',
        filterSelectOptions: types.map(item => ({...item, value: item.value.toString()}))
      },
      {
        accessorKey: "internetPlan.name",
        header: "Plan de Internet",
        filterVariant: 'select',
        filterSelectOptions: internetPlans.map(item => ({...item, value: item.value.toString()}))
      },
      {
        accessorKey: "mobilePlan.name",
        header: "Plan Movil",
        filterVariant: 'select',
        filterSelectOptions: mobilePlans.map(item => ({...item, value: item.value.toString()}))
      },
      {
        accessorKey: "videoPlan.name",
        header: "Plan de Video",
        filterVariant: 'select',
        filterSelectOptions: videoPlans.map(item => ({...item, value: item.value.toString()}))
      },
      {
        accessorKey: "price",
        header: "Precio",
        enableColumnFilter: false
      },
      {
        accessorKey: "promoPrice",
        header: "Precio Promoción",
        enableColumnFilter: false
      },
      {
        accessorKey: "promoPriceDuration",
        header: "Duración Promoción",
        enableColumnFilter: false
      },
    ],
    [classifications, internetPlans, mobilePlans, plays, types, videoPlans]
  );

  const getOffers = React.useCallback(() => {
    setIsLoading(true);
    const token = localStorage.getItem("jwt");
    const classificationId: string = columnFilters.find(item => item.id === 'classification.name')?.['value'] as string || '' ;
    const typeId: string = columnFilters.find(item => item.id === 'type.name')?.['value'] as string || '' ;
    const playId: string = columnFilters.find(item => item.id === 'play.name')?.['value'] as string || '' 
    const internetPlanId: string = columnFilters.find(item => item.id === 'internetPlan.name')?.['value'] as string || '' 
    const mobilePlanId: string = columnFilters.find(item => item.id === 'mobilePlan.name')?.['value'] as string || '' 
    const videoPlanId: string = columnFilters.find(item => item.id === 'videoPlan.name')?.['value'] as string || '' 
    const params = new URLSearchParams({
      page: pagination.pageIndex.toString(),
      classificationId: classificationId,
      typeId: typeId,
      playId,
      internetPlanId,
      mobilePlanId,
      videoPlanId,
    });
    fetch(`${API_URL}/ofertas?${params.toString()}`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: OfferResponse) => {
        setIsLoading(false);
        setData(response.content);
        setRowCount(response.totalElements);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [columnFilters, pagination.pageIndex]);

  const getClassifications = () => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/clasificaciones`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setClassifications(response);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getAcs = () => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/acs`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setAcs(response);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getPlays = () => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/plays`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setPlays(response);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getTypes = () => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/offer-types`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setTypes(response);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getInternetPlans = () => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/plans/internet`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setInternetPlans(response);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getMobilePlans = () => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/plans/mobile`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setMobilePlans(response);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getVideoPlans = () => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/plans/video`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setVideoPlans(response);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getCompetitors = () => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/competidores`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: catalog[]) => {
        setCompetitors(response);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const createOffer = () => {
    const token = localStorage.getItem("jwt");
    const data: OfferState = { ...state };
    (Object.keys(data) as Array<keyof OfferState>).forEach((item) => {
      if (data[item] === 0 || data[item] === "") {
        data[item] = null as never;
      }
    });
    fetch(`${API_URL}/ofertas`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: OfferRow) => {
        if (response.id) {
          swal({
            title: "Guardado!",
            text: "Se ha guardado correctamente! :)",
            icon: "success",
          });
          setOpen(false);
          setModalTitle("");
          dispatch({ type: "SET_STATE", payload: initialState });
          getOffers();
          sentActionLog('Create_Offer', `Creo una nueva oferta con id: ${response.id}`);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const editOffer = () => {
    const token = localStorage.getItem("jwt");
    const data: OfferState = { ...state };
    (Object.keys(data) as Array<keyof OfferState>).forEach((item) => {
      if (data[item] === 0 || data[item] === "") {
        data[item] = null as never;
      }
    });
    fetch(`${API_URL}/ofertas/${data.id}`, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response: OfferRow) => {
        if (response.id) {
          swal({
            title: "Guardado!",
            text: "Se ha guardado correctamente! :)",
            icon: "success",
          });
          setOpen(false);
          setModalTitle("");
          dispatch({ type: "SET_STATE", payload: initialState });
          getOffers();
          sentActionLog('Edit_Offer', `Edito una oferta con id: ${response.id}`);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const validateFields = () => {
    let isValid = true;
    const keys = Object.keys(state) as Array<keyof OfferState>;
    for (let i = 0; i < keys.length; i++) {
      if (keys[i] === "classificationId") {
        if (state[keys[i]] === 0) {
          setError({
            field: "classificationId",
            message: "Clasificación no puede estar vacia",
          });
          isValid = false;
          break;
        }
      } else if (keys[i] === "acId") {
        if (state[keys[i]] === 0) {
          setError({ field: "acId", message: "AC no puede estar vacio" });
          isValid = false;
          break;
        }
      } else if (keys[i] === "playId") {
        if (state[keys[i]] === 0) {
          setError({ field: "playId", message: "Play no puede estar vacio" });
          isValid = false;
          break;
        }
      } else if (keys[i] === "typeId") {
        if (state[keys[i]] === 0) {
          setError({ field: "typeId", message: "Tipo no puede estar vacio" });
          isValid = false;
          break;
        }
      } else if (
        keys[i] === "internetPlanId" ||
        keys[i] === "mobilePlanId" ||
        keys[i] === "videoPlanId"
      ) {
        if (
          state.internetPlanId === undefined &&
          state.mobilePlanId === undefined &&
          state.videoPlanId === undefined
        ) {
          setError({
            field: "internetPlanId",
            message: "Internet, Movil y Video no pueden estar todos vacios",
          });
          isValid = false;
          break;
        }
      } else if (keys[i] === "price") {
        if (state[keys[i]] === "") {
          setError({ field: "price", message: "Precio no puede estar vacio" });
          isValid = false;
          break;
        }
      } else {
        setError(undefined);
      }
    }
    return isValid;
  };

  React.useEffect(() => {
    getOffers();
  }, [getOffers, pagination.pageIndex, pagination.pageSize, columnFilters]);

  React.useEffect(() => {
    getClassifications();
    getTypes();
    getPlays();
    getInternetPlans();
    getVideoPlans();
    getMobilePlans();
    sentActionLog('Visit_Offers', 'Entro en la vista Ofertas');
  },[]);

  React.useEffect(() => {
    (async () => {
      if (!["/", "/login"].includes(location.pathname)) {
        const currentToken = localStorage.getItem("jwt");
        if (currentToken) {
          const isValid = await verify(currentToken);
          if (!isValid) {
            navigate("/");
          } else {
            const permissions = JSON.parse(
              localStorage.getItem("user") || "{}"
            );
            if (!permissions?.administrationAccess) {
              navigate("/Home");
            }
          }
        } else {
          navigate("/");
        }
      }
    })();
  }, [location.pathname, navigate]);

  const handleDelete = (row: OfferRow) => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/ofertas/${row.id}`, {
      method: "DELETE",
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.ok)
      .then((response: boolean) => {
        if (response) {
          swal({
            title: "Eliminado!",
            text: "Se ha eliminado correctamente! :)",
            icon: "success",
          });
          getOffers();
          sentActionLog('Delete_Offer', `Elimino una oferta con id: ${row.id}`);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleEdit = (row: OfferRow) => {
    const state = {
      id: row.id,
      classificationId: row.classification.id,
      acId: row.ac?.id,
      playId: row.play.id,
      typeId: row.type.id,
      internetPlanId: row.internetPlan?.id,
      mobilePlanId: row.mobilePlan?.id,
      videoPlanId: row.videoPlan?.id,
      expirationDate: row.expiration,
      internetPlanPromoId: row.internetPlanPromo?.id,
      internetPlanPromoDuration: row.internetPlanPromoDuration,
      advancePaymentPromo: row.advancePaymentPromo,
      channelsApps: row.channelsApps,
      permanentPromo: row.permanentPromo,
      promoPrice: row.promoPrice,
      price: row.price,
      promoPriceDuration: row.promoPriceDuration,
      addMobilePromo: row.addMobilePromo,
      addMobilePromoDuration: row.addMobilePromoDuration,
      arguments: row.arguments.map((item) => ({
        competitorId: item.competitor?.id,
        plan: item.plan,
        competitorPrice: item.competitorPrice,
        competitorPromoPrice: item.competitorPromoPrice,
        promos: item.promos,
        description: item.description,
      })),
    };
    dispatch({ type: "SET_STATE", payload: state });
    handleOpen("Editar");
  };

  const handleSave = () => {
    if (modalTitle) {
      if (modalTitle === "Crear") {
        if (validateFields()) {
          createOffer();
        }
      } else if (modalTitle === "Editar") {
        editOffer();
      }
    }
  };

  const handleSaveArgument = () => {
    setOpenAddArgument(false);
    dispatch({
      type: "SET_ARGUMENTS",
      payload: [...state.arguments, argumentState],
    });
    argumentDispatch({ type: "SET_STATE", payload: argumentInitialState });
  };

  const handleOpen = (title: string) => {
    getAcs();
    getPlays();
    getTypes();
    getInternetPlans();
    getMobilePlans();
    getVideoPlans();
    getCompetitors();
    setModalTitle(title);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setModalTitle("");
    dispatch({ type: "SET_STATE", payload: initialState });
  };

  const handleCloseAddArgument = () => {
    setOpenAddArgument(false);
  };

  const handleInputChange = (value: any, type: ActionTypes) => {
    dispatch({ type: type, payload: value });
  };

  const handleArgumentInputChange = (value: any, type: ArgumentActionTypes) => {
    argumentDispatch({ type: type, payload: value });
  };

  const handleRemoveArgument = (index: number) => {
    const newArguments = [...state.arguments];
    newArguments.splice(index, 1);
    dispatch({ type: "SET_ARGUMENTS", payload: newArguments });
  };

  const table = useMaterialReactTable({
    columns,
    data,
    enableFilters: true,
    enableColumnFilters: true,
    enableHiding: false,
    enableSorting: false,
    enableColumnActions: false,
    enableRowActions: true,
    manualPagination: true,
    manualFiltering: true,
    paginationDisplayMode: 'pages',
    onPaginationChange: setPagination,
    rowCount,
    positionActionsColumn: "last",
    renderToolbarInternalActions: ({ table }) => (
      <>
        <IconButton onClick={() => handleOpen("Crear")}>
          <AddIcon />
        </IconButton>
        <MRT_ToggleDensePaddingButton table={table} />
        <MRT_ToggleFullScreenButton table={table} />
      </>
    ),
    renderRowActions: ({ row }) => (
      <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
        <IconButton color="primary" onClick={() => handleEdit(row.original)}>
          <Edit />
        </IconButton>
        <IconButton color="error" onClick={() => handleDelete(row.original)}>
          <Delete />
        </IconButton>
      </Box>
    ),
    onColumnFiltersChange: setColumnFilters,
    state: {
      isLoading,
      pagination,
      columnFilters
    },
    initialState: { showColumnFilters: true },
    muiBottomToolbarProps: {
      sx: {
        backgroundColor: "#f5f5f5",
      },
    },
    muiTableHeadRowProps: {
      sx: {
        backgroundColor: "#f5f5f5",
      },
    },
    muiTableBodyRowProps: {
      sx: {
        backgroundColor: "#f5f5f5",
      },
    },
    muiTopToolbarProps: {
      sx: {
        backgroundColor: "#f5f5f5",
      },
    },
  });

  const renderItems = (catalog: catalog[]) => {
    return catalog.map((item) => (
      <MenuItem value={item.value}>{item.label}</MenuItem>
    ));
  };

  const renderArguments = () => {
    return state.arguments.map((item, index) => (
      <Box border={"1px solid #0000003b"} p={1} position={"relative"}>
        <IconButton
          style={{ position: "absolute", right: 10 }}
          color="error"
          onClick={() => handleRemoveArgument(index)}
        >
          <Delete />
        </IconButton>
        <Typography>Competidor: {item.competitorId}</Typography>
        <Typography>Plan: {item.plan}</Typography>
        <Typography>Precio: {item.competitorPrice} </Typography>
        <Typography>Precio Promoción: {item.competitorPromoPrice} </Typography>
        <Typography>Promos: {item.promos} </Typography>
        <Typography>Descripción: {item.description} </Typography>
      </Box>
    ));
  };

  return (
    <Box width={"100%"} mb={8}>
      <NavBar />
      <IconButton onClick={() => navigate(-1)}>
        <ArrowBackIcon />
      </IconButton>
      <Card sx={{ minWidth: 275 }}>
        <CardContent>
          <MaterialReactTable table={table} />
        </CardContent>
      </Card>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="Create-Edit-Offer"
      >
        <ModalContainer theme={theme}>
          <Box display={"flex"} flexDirection="row-reverse">
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box p={4} pt={0} maxHeight={"380px"} overflow={"auto"}>
            <Typography mb={2} variant="h5" fontWeight="bold">
              {modalTitle} Oferta
            </Typography>
            <FormControl fullWidth error={error?.field === "classificationId"}>
              <InputLabel color="secondary" id="classification">
                Clasificación
              </InputLabel>
              <Select
                color="secondary"
                labelId="classification"
                value={state.classificationId}
                label="Clasificación"
                onChange={(e) =>
                  handleInputChange(e.target.value, "SET_CLASSIFICATION")
                }
              >
                {renderItems(classifications)}
              </Select>
              {error?.field === "classificationId" && (
                <FormHelperText>{error.message}</FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth error={error?.field === "acId"}>
              <InputLabel color="secondary" id="acs">
                Ac
              </InputLabel>
              <Select
                color="secondary"
                labelId="acs"
                value={state.acId}
                label="Ac"
                onChange={(e) => handleInputChange(e.target.value, "SET_AC")}
              >
                {renderItems(acs)}
              </Select>
              {error?.field === "acId" && (
                <FormHelperText>{error.message}</FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth error={error?.field === "playId"}>
              <InputLabel color="secondary" id="plays">
                Play
              </InputLabel>
              <Select
                color="secondary"
                labelId="plays"
                value={state.playId}
                label="Play"
                onChange={(e) => handleInputChange(e.target.value, "SET_PLAY")}
              >
                {renderItems(plays)}
              </Select>
              {error?.field === "playId" && (
                <FormHelperText>{error.message}</FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth error={error?.field === "typeId"}>
              <InputLabel color="secondary" id="type">
                Types
              </InputLabel>
              <Select
                color="secondary"
                labelId="type"
                value={state.typeId}
                label="Types"
                onChange={(e) => handleInputChange(e.target.value, "SET_TYPE")}
              >
                {renderItems(types)}
              </Select>
              {error?.field === "typeId" && (
                <FormHelperText>{error.message}</FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth error={error?.field === "internetPlanId"}>
              <InputLabel color="secondary" id="internetPlan">
                Plan de Internet
              </InputLabel>
              <Select
                color="secondary"
                labelId="internetPlan"
                value={state.internetPlanId}
                label="Plan de Internet"
                onChange={(e) =>
                  handleInputChange(e.target.value, "SET_INTERNETPLAN")
                }
              >
                {renderItems(internetPlans)}
              </Select>
              {error?.field === "internetPlanId" && (
                <FormHelperText>{error.message}</FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth error={error?.field === "internetPlanId"}>
              <InputLabel color="secondary" id="MobilePlan">
                Plan Móvil
              </InputLabel>
              <Select
                color="secondary"
                labelId="MobilePlan"
                value={state.mobilePlanId}
                label="Plan Móvil"
                onChange={(e) =>
                  handleInputChange(e.target.value, "SET_MOBILEPLAN")
                }
              >
                {renderItems(mobilePlans)}
              </Select>
              {error?.field === "internetPlanId" && (
                <FormHelperText>{error.message}</FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth error={error?.field === "internetPlanId"}>
              <InputLabel color="secondary" id="videoPlan">
                Plan de Video
              </InputLabel>
              <Select
                color="secondary"
                labelId="videoPlan"
                value={state.videoPlanId}
                label="Plan de Video"
                onChange={(e) =>
                  handleInputChange(e.target.value, "SET_VIDEOPLAN")
                }
              >
                {renderItems(videoPlans)}
              </Select>
              {error?.field === "internetPlanId" && (
                <FormHelperText>{error.message}</FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth>
              <TextField
                error={error?.field === "price"}
                color="secondary"
                label="Fecha de Expiración"
                placeholder="YYYY-MM-DD"
                variant="outlined"
                value={state.expirationDate}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(event.target.value, "SET_EXPIRATIONDATE");
                }}
              />
              {error?.field === "price" && (
                <FormHelperText>{error.message}</FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Duración de Plan de Promoción"
                variant="outlined"
                value={state.internetPlanPromoDuration}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(
                    event.target.value,
                    "SET_INTERNETPLANPROMODURATION"
                  );
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Promoción Pago Adelantado"
                variant="outlined"
                value={state.advancePaymentPromo}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(
                    event.target.value,
                    "SET_ADVANCEPAYMENTPROMO"
                  );
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Aplicaciones y canales"
                variant="outlined"
                value={state.channelsApps}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(event.target.value, "SET_CHANNELAPPS");
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Promoción Permanente"
                variant="outlined"
                value={state.permanentPromo}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(event.target.value, "SET_PERMANENTPROMO");
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                error={error?.field === "price"}
                color="secondary"
                label="Precio"
                variant="outlined"
                value={state.price}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(event.target.value, "SET_PRICE");
                }}
              />
              {error?.field === "price" && (
                <FormHelperText>{error.message}</FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Precio Promoción"
                variant="outlined"
                value={state.promoPrice}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(event.target.value, "SET_PROMOPRICE");
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Duración del Precio de Promoción"
                variant="outlined"
                value={state.promoPriceDuration}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(
                    event.target.value,
                    "SET_PROMOPRICEDURATION"
                  );
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Promoción Móvil"
                variant="outlined"
                value={state.addMobilePromo}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(event.target.value, "SET_ADDMOBILEPROMO");
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Duración Promoción Móvil"
                variant="outlined"
                value={state.addMobilePromoDuration}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(
                    event.target.value,
                    "SET_ADDMOBILEPROMODURATION"
                  );
                }}
              />
            </FormControl>
            {renderArguments()}
            <Button
              variant="outlined"
              color="secondary"
              style={{ marginBottom: theme.spacing(1) }}
              onClick={() => setOpenAddArgument(true)}
            >
              Agregar Argumento
            </Button>
            <Button variant="contained" color="secondary" onClick={handleSave}>
              Guardar
            </Button>
          </Box>
        </ModalContainer>
      </Modal>
      <Modal
        open={openAddArgument}
        onClose={handleCloseAddArgument}
        aria-labelledby="Create-Edit-Offer"
      >
        <ModalContainer theme={theme}>
          <Box display={"flex"} flexDirection="row-reverse">
            <IconButton onClick={handleCloseAddArgument}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box p={4} pt={1} maxHeight={"380px"} overflow={"auto"}>
            <FormControl fullWidth>
              <InputLabel color="secondary" id="classification">
                Competidores
              </InputLabel>
              <Select
                color="secondary"
                labelId="classification"
                value={argumentState.competitorId}
                label="Clasificación"
                onChange={(e) =>
                  handleArgumentInputChange(e.target.value, "SET_COMPETITOR")
                }
              >
                {renderItems(competitors)}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Plan"
                variant="outlined"
                value={argumentState.plan}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleArgumentInputChange(event.target.value, "SET_PLAN");
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Precio Competidor"
                variant="outlined"
                value={argumentState.competitorPrice}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleArgumentInputChange(
                    event.target.value,
                    "SET_COMPETITORPRICE"
                  );
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Precio Promoción Competidor"
                variant="outlined"
                value={argumentState.competitorPromoPrice}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleArgumentInputChange(
                    event.target.value,
                    "SET_COMPETITORPROMOPRICE"
                  );
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Promos"
                variant="outlined"
                value={argumentState.promos}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleArgumentInputChange(event.target.value, "SET_PROMOS");
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                color="secondary"
                label="Descripción"
                variant="outlined"
                value={argumentState.description}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleArgumentInputChange(
                    event.target.value,
                    "SET_DESCRIPTION"
                  );
                }}
              />
            </FormControl>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSaveArgument}
            >
              Agregar
            </Button>
          </Box>
        </ModalContainer>
      </Modal>
    </Box>
  );
};

export default Offers;
